module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "error-page"
  }, [_c('div', {
    staticClass: "error-page__close",
    on: {
      "click": _vm.back
    }
  }, [_vm._v("< Back")]), _vm._v(" "), _c('div', {
    staticClass: "error-page__header"
  }, [_vm._v(_vm._s(_vm.header))]), _vm._v(" "), _c('div', {
    staticClass: "error-page__body"
  }, [_vm._v(_vm._s(_vm.msg))]), _vm._v(" "), _c('div', {
    staticClass: "error-page__action"
  }, [(_vm.hasLimitBeenHit) ? _c('div', [_c('small', [_vm._v("Please visit our website to complete your enquiry")]), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('a', {
    attrs: {
      "href": _vm.link,
      "title": "Complete booking on DesignMyNight",
      "target": "_blank"
    }
  }, [_vm._v("\n                    Complete Booking on DesignMyNight\n                ")])])]) : _c('div', [_c('div', {
    staticClass: "flex"
  }, [_c('button', {
    staticClass: "button",
    on: {
      "click": _vm.action
    }
  }, [_vm._v("\n                    Try Again\n                ")]), _vm._v(" "), (_vm.showBookBtn) ? _c('button', {
    staticClass: "button",
    on: {
      "click": _vm.book
    }
  }, [_vm._v("\n                    Book on DesignMyNight\n                ")]) : _vm._e()])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-411f3422","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/errorPage.vue
// module id = 598
// module chunks = 0